module.exports = __webpack_public_path__ + "static/img/emotions1_08.d837bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/images/emotions1_08.png
// module id = Wnzz
// module chunks = 0